// c_zeta-search.js — ZETA検索結果ページUI。window.Zeta経由の結果を<template>描画し、ファセット選択をURL同期（pushState/popstate対応）する。

(function () {
  'use strict';

  const root = document.querySelector('[data-c_zeta-search]');
  if (!root) return;
  if (!window.Zeta) {
    console.warn('[c_zeta-search] window.Zeta が初期化されていません。c_zeta.js の読み込みを確認してください。');
    return;
  }

  const $ = (sel, ctx) => (ctx || root).querySelector(sel);
  const grid = $('[data-c_zeta-search-grid]');
  const status = $('[data-c_zeta-search-status]');
  const paginationEl = $('[data-c_zeta-search-pagination]');
  const countEl = $('[data-c_zeta-search-count]');
  const titleEl = $('[data-c_zeta-search-title]');
  const tplCard = root.querySelector('[data-c_zeta-card-template]');
  const tplFacetGroup = document.getElementById('c_zeta-facet-group-template');
  const tplFacetOption = document.getElementById('c_zeta-facet-option-template');

  const facetsAside = $('[data-c_zeta-search-facets]');
  const facetsList = $('[data-c_zeta-search-facets-list]');
  const activeFiltersBar = $('[data-c_zeta-search-active-filters]');
  const chipsList = $('[data-c_zeta-search-chips]');
  const clearAllBtn = $('[data-c_zeta-search-clear-all]');
  const toolbarEl = $('[data-c_zeta-search-toolbar]');
  const sortEl = $('[data-c_zeta-search-sort]');
  const openFacetsBtn = $('[data-c_zeta-search-open-facets]');
  const closeFacetsBtn = $('[data-c_zeta-search-close-facets]');
  const openSortBtn = $('[data-c_zeta-search-open-sort]');
  const spBar = $('[data-c_zeta-search-sp-bar]');
  const overlayEl = $('[data-c_zeta-search-overlay]');
  // パンくずはセクション外＋上下2箇所に配置されるためdocumentから全件取得する
  const breadcrumbEls = document.querySelectorAll('[data-c_zeta-search-breadcrumb]');

  // セクション設定（Liquidが出力した application/json）
  const sectionConfig = (() => {
    const node = $('[data-c_zeta-search-config]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (_) {
      return {};
    }
  })();

  // キーが無い検索ページでは各UIを既定で表示する
  const showFilters = sectionConfig.showFilters !== false;
  const showSortBy = sectionConfig.showSortBy !== false;
  const showPagination = sectionConfig.showPagination !== false;
  const showCount = sectionConfig.showCount !== false;

  // 固定の取得条件（コレクションページ用 2-4〜2-6）。ユーザー操作で変更不可・URLにも載せず、毎回のAPIリクエストへ強制適用する。
  const baseParams = sectionConfig.baseParams || {};
  const baseKeys = Object.keys(baseParams).filter((k) => baseParams[k] !== '' && baseParams[k] != null);

  // ファセット定義: フィールド名→表示ラベル/子階層フラグ/初期開閉（本番BoostAI実測準拠: 販売タイプ〜カテゴリーが初期展開）。
  const FACET_DEFS = [
    { key: 'gender', label: '性別', hasChildren: false, defaultOpen: true },
    { key: 'saletype', label: '販売タイプ', hasChildren: false, defaultOpen: true },
    { key: 'stock_flg', label: '在庫状況', hasChildren: false, defaultOpen: true },
    { key: 'category', label: 'カテゴリー', hasChildren: true, defaultOpen: true }, // TODO: クライアント確認後 — 階層UI採用の最終承認
    { key: 'brand', label: 'ブランド', hasChildren: false },
    { key: 'selectbrand', label: 'セレクトブランド', hasChildren: false },
    { key: 'color', label: 'カラー', hasChildren: false },
    { key: 'size', label: 'サイズ', hasChildren: false },
    { key: 'fieldlevel', label: 'フィールドレベル', hasChildren: false }
  ];
  const FACET_KEYS = FACET_DEFS.map((d) => d.key);

  // サイドバー表示順（mix.tokyo実測準拠・価格はブランドとカラーの間）。'__price__'=価格の挿入位置
  const DISPLAY_ORDER = (() => {
    const arr = [];
    FACET_DEFS.forEach((d) => {
      arr.push(d.key);
      if (d.key === 'selectbrand') arr.push('__price__');
    });
    return arr;
  })();

  // 在庫状況（value=1=在庫あり/0=在庫なし）。初期状態では在庫の絞り込みを適用しない（URLで指定された場合のみ適用）。

  // 価格レンジ（ファセット返却が無いため入力欄で自前構築）
  const PRICE_FROM_KEY = 'price__from';
  const PRICE_TO_KEY = 'price__to';
  const PRICE_MIN = 300;
  const PRICE_MAX = 500000;
  const PRICE_STEP = 1000;
  // 下限・上限がともに指定され、固定境界と一致する全レンジか判定する。
  const isFullPriceRange = (from, to) =>
    from !== '' && from != null && to !== '' && to != null && Number(from) === PRICE_MIN && Number(to) === PRICE_MAX;

  const COLOR_SWATCHES = {
    ホワイト: '#ffffff',
    ブラック: '#000000',
    グレー: '#808080',
    ベージュ: '#d8c29d',
    ブラウン: '#7b4a2d',
    カーキ: '#7a6a45',
    レッド: '#e60012',
    ワインレッド: '#b33e5c',
    ピンク: '#f5a3b7',
    オレンジ: '#f39800',
    イエロー: '#ffe200',
    グリーン: '#009944',
    ライトグリーン: '#90ee90',
    ブルー: '#0068b7',
    ネイビー: '#1a2a52',
    パープル: '#7f1184',
    ゴールド: 'linear-gradient(135deg, #e7c973, #b8933d)',
    シルバー: 'linear-gradient(135deg, #e8e8e8, #b5b5b5)'
  };

  // 適用モード（仕様5/15確定）。PC即時 / PC OKボタン / SPは全項目一括。
  const IMMEDIATE_FACETS = new Set(['saletype', 'stock_flg', 'gender', 'category', 'size', 'fieldlevel']);
  const OK_FACETS = new Set(['brand', 'color', 'selectbrand']); // 複数選択→OKボタンで適用（価格は専用ボタン）
  const MODAL_FACETS = new Set(['selectbrand']); // 頭文字検索付きモーダルで選択
  const ICON_FACETS = new Set(['fieldlevel']); // 山アイコン表示
  const SLIDE_FACETS = new Set(['category', 'brand', 'color']); // SPはカテゴリ/ブランド/カラーを横スライドのサブパネルで表示
  const SIZE_SOURCE_FACETS = new Set(['category', 'brand']); // 選択するとサイズ項目の表示条件を満たすキー
  const SELECTED_LABEL_KEYS = ['category', 'brand', 'selectbrand', 'color'];
  const facetNameMaps = {};

  const SP_MQ = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 991px)') : null;
  const isSP = () => (SP_MQ ? SP_MQ.matches : window.innerWidth <= 991);
  const isImmediate = (key) => !isSP() && IMMEDIATE_FACETS.has(key); // トグルで即fetchするか

  // 本番実測順。関連性はZETA API未対応のため除外。
  const COLLECTION_ORDER_SORT = 'collectionorder';
  const SORT_OPTIONS = [
    { value: '-start_date', label: '新着順' },
    { value: '-sales', label: 'ベストセラー順' },
    { value: '-score', label: 'おすすめ順' },
    { value: 'price', label: '価格の安い順' },
    { value: '-price', label: '価格の高い順' },
    { value: '-discountrate', label: '割引率の高い順' },
    { value: 'discountrate', label: '割引率の低い順' },
    { value: COLLECTION_ORDER_SORT, label: 'ピックアップアイテム' }
  ];
  const COLLECTION_DEFAULT_SORT = '-start_date'; // コレクションページは新着順のまま
  const SEARCH_DEFAULT_SORT = '-score'; // キーワード検索はおすすめ順（クライアント指定）
  const SORT_VALUES = SORT_OPTIONS.map((o) => o.value);
  // 手動並びはcollectionを1つだけ固定しているページ（コレクションページ）でのみ有効
  const isCollectionOrderAvailable = () =>
    baseKeys.indexOf('collection') !== -1 &&
    String(baseParams.collection).split(',').filter(Boolean).length === 1;
  const configuredCollectionSort = SORT_VALUES.indexOf(sectionConfig.defaultSort) !== -1
    ? sectionConfig.defaultSort
    : COLLECTION_DEFAULT_SORT;
  const collectionDefaultSort = configuredCollectionSort === COLLECTION_ORDER_SORT && !isCollectionOrderAvailable()
    ? COLLECTION_DEFAULT_SORT
    : configuredCollectionSort;
  const DEFAULT_SORT = baseKeys.indexOf('collection') !== -1 ? collectionDefaultSort : SEARCH_DEFAULT_SORT;
  const availableSortOptions = () =>
    SORT_OPTIONS.filter((option) => option.value !== COLLECTION_ORDER_SORT || isCollectionOrderAvailable());

  // state: 単一の真のソース。filtersは{ key: Set<string> }（同一キー内OR / キー間AND）。priceFrom/priceToは価格レンジ。
  const state = {
    q: '',
    l: sectionConfig.productsPerPage || 24,
    o: 0,
    s: DEFAULT_SORT,
    filters: {},
    priceFrom: '',
    priceTo: ''
  };

  // draft: 作業中の選択（チェック表示の真のソース）。applyFacet/applyAllでstate.filtersへ反映。
  const draft = { filters: {}, priceFrom: '', priceTo: '' };
  const seedDraft = () => {
    draft.filters = {};
    Object.keys(state.filters).forEach((k) => {
      draft.filters[k] = new Set(state.filters[k]);
    });
    draft.priceFrom = state.priceFrom;
    draft.priceTo = state.priceTo;
  };

  // ファセットentriesから値→表示名マップを作る（カテゴリは子階層も含める）
  const buildFacetNameMap = (entries) => {
    const map = new Map();
    const walk = (list) => {
      list.forEach((entry) => {
        map.set(String(entry.value), entry.name != null ? String(entry.name) : String(entry.value));
        if (Array.isArray(entry.child)) walk(entry.child);
      });
    };
    walk(entries || []);
    return map;
  };

  // SP横スライド行の「選択中項目名」表示をdraftから更新する
  const updateSelectedLabels = () => {
    if (!facetsList) return;
    SELECTED_LABEL_KEYS.forEach((key) => {
      const group = facetsList.querySelector(`[data-c-zeta-facet-group='${key}']`);
      if (!group) return;
      const selectedEl = group.querySelector('[data-c_zeta-facet-selected]');
      if (!selectedEl) return;
      const values = draft.filters[key] ? Array.from(draft.filters[key]) : [];
      const map = facetNameMaps[key];
      const names = values.map((value) => (map && map.get(value)) || value);
      selectedEl.textContent = names.join(' / ');
      selectedEl.hidden = names.length === 0;
    });
  };

  // 直近のファセット応答（SPドロワーの再描画・件数表示に使用）
  let lastFacet = {};
  let lastNonEmptyFacet = null;
  let lastHasResults = false;
  let lastTotal = 0;

  const stateFromUrl = (isInitial) => {
    const u = new URLSearchParams(window.location.search);
    state.q = u.get('q') || '';
    state.l = Number(u.get('l')) || sectionConfig.productsPerPage || 24;
    state.o = Number(u.get('o')) || 0;
    const sortValue = u.get('s') || DEFAULT_SORT;
    state.s = sortValue === COLLECTION_ORDER_SORT && !isCollectionOrderAvailable() ? DEFAULT_SORT : sortValue;
    state.filters = {};
    FACET_KEYS.forEach((key) => {
      const v = u.get(key);
      if (!v) return;
      // カンマ区切りOR（仕様書通り）
      const values = v.split(',').map((x) => x.trim()).filter(Boolean);
      if (values.length) state.filters[key] = new Set(values);
    });
    // 価格レンジ
    state.priceFrom = u.get(PRICE_FROM_KEY) || '';
    state.priceTo = u.get(PRICE_TO_KEY) || '';

    seedDraft(); // 適用状態をdraftへ複製
  };

  // draftをAPIパラメータへ変換（SP件数プレビューのBG取得用）
  const draftToApiParams = () => {
    const params = { q: state.q, l: state.l, o: 0, s: state.s };
    Object.keys(draft.filters).forEach((key) => {
      const set = draft.filters[key];
      if (set && set.size) params[key] = Array.from(set).join(',');
    });
    if (!isFullPriceRange(draft.priceFrom, draft.priceTo)) {
      if (draft.priceFrom) params[PRICE_FROM_KEY] = String(window.Zeta.toTaxExcludedFloor(Number(draft.priceFrom)));
      if (draft.priceTo) params[PRICE_TO_KEY] = String(window.Zeta.toTaxExcludedCeil(Number(draft.priceTo)));
    }
    baseKeys.forEach((k) => {
      params[k] = baseParams[k];
    });
    return params;
  };

  // stateからURLクエリ文字列を生成（カンマ区切りOR形式。zeta_dev / zeta_dev_patternはモード切替用に維持）。
  const buildUrlFromState = () => {
    const u = new URLSearchParams();
    if (state.q) u.set('q', state.q);
    if (state.l && state.l !== (sectionConfig.productsPerPage || 24)) u.set('l', String(state.l));
    if (state.o) u.set('o', String(state.o));
    if (state.s && state.s !== DEFAULT_SORT) u.set('s', state.s);
    Object.keys(state.filters).forEach((key) => {
      const set = state.filters[key];
      if (set && set.size) u.set(key, Array.from(set).join(','));
    });
    if (!isFullPriceRange(state.priceFrom, state.priceTo)) {
      if (state.priceFrom) u.set(PRICE_FROM_KEY, state.priceFrom);
      if (state.priceTo) u.set(PRICE_TO_KEY, state.priceTo);
    }
    // 開発モード関連パラメータは維持
    const original = new URLSearchParams(window.location.search);
    ['zeta_dev', 'zeta_dev_pattern'].forEach((k) => {
      if (original.has(k)) u.set(k, original.get(k));
    });
    return u.toString();
  };

  // stateをZeta APIリクエストパラメータへ変換（仕様書「絞り込みパラメータ > 文字列フィールド用パラメータ」準拠）。
  const stateToApiParams = () => {
    const params = { q: state.q, l: state.l, o: state.o, s: state.s };
    Object.keys(state.filters).forEach((key) => {
      const set = state.filters[key];
      if (set && set.size) params[key] = Array.from(set).join(',');
    });
    if (!isFullPriceRange(state.priceFrom, state.priceTo)) {
      if (state.priceFrom) params[PRICE_FROM_KEY] = String(window.Zeta.toTaxExcludedFloor(Number(state.priceFrom)));
      if (state.priceTo) params[PRICE_TO_KEY] = String(window.Zeta.toTaxExcludedCeil(Number(state.priceTo)));
    }
    // 固定条件は最後に適用（同キーのユーザー選択より固定値を優先＝コレクションの範囲を維持）
    baseKeys.forEach((k) => {
      params[k] = baseParams[k];
    });
    return params;
  };

  // ---------- 描画ヘルパー ----------
  const clearChildren = (el) => {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  };

  // 商品カードの生成は window.Zeta.buildProductCard に共通化（特集コレクションと共用）。
  const buildCard = (item) =>
    window.Zeta.buildProductCard(item, tplCard, { selectedColors: state.filters.color || null });

  // ---------- ファセット描画 ----------
  // フィールドレベルを常に3つの山で示し、選択レベルを濃淡で表現する。
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const makeMountainIcon = (level) => {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'c_zeta-facet-option__mountain');
    svg.setAttribute('width', '51');
    svg.setAttribute('height', '14');
    svg.setAttribute('viewBox', '0 0 51 14');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    [
      'M4.72727 7L0 13.5H12.4091L10.0455 9.95455L8.27273 11.7273L4.72727 7Z',
      'M21.6429 5L16.5 13H30.7857L26.2143 5L23.9286 7.28571L21.6429 5Z',
      'M39.64 3.12L35 13H50.56L43.8 0L41.2 5.2L39.64 3.12Z'
    ].forEach((d, index) => {
      const path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', d);
      path.setAttribute('fill', 'currentColor');
      if (index >= level) path.setAttribute('opacity', '0.15');
      svg.appendChild(path);
    });
    return svg;
  };

  // ファセット内の単一オプション（チェックボックス1つ分）を生成（isChildで子階層オプションか判定）。
  const buildFacetOption = (def, entry, isChild) => {
    const node = tplFacetOption.content.firstElementChild.cloneNode(true);
    const checkbox = node.querySelector('[data-c_zeta-facet-checkbox]');
    const label = node.querySelector('.c_zeta-facet-option__label');
    const nameEl = node.querySelector('[data-c_zeta-facet-name]');
    const countEl2 = node.querySelector('[data-c_zeta-facet-count]');
    const childToggle = node.querySelector('[data-c_zeta-facet-child-toggle]');
    const childrenWrap = node.querySelector('[data-c_zeta-facet-children]');

    const valueStr = String(entry.value);
    checkbox.value = valueStr;
    checkbox.dataset.cZetaFacetKey = def.key;
    // チェック表示はdraftが真のソース
    if (draft.filters[def.key] && draft.filters[def.key].has(valueStr)) {
      checkbox.checked = true;
    }
    if (ICON_FACETS.has(def.key)) {
      const level = parseInt(valueStr, 10) || 0;
      nameEl.classList.add('c_zeta-facet-option__level');
      nameEl.setAttribute('aria-label', `フィールドレベル ${valueStr}`);
      if (level > 0) {
        nameEl.textContent = '';
        nameEl.appendChild(makeMountainIcon(Math.min(level, 3)));
      } else {
        nameEl.textContent = entry.name != null ? String(entry.name) : valueStr;
      }
    } else {
      nameEl.textContent = entry.name != null ? String(entry.name) : valueStr;
    }
    countEl2.textContent = entry.count != null ? `(${entry.count})` : '';
    if (def.key === 'color') {
      const colorName = entry.name != null ? String(entry.name) : valueStr;
      const accessibleName = `${colorName}${entry.count != null ? `（${entry.count}）` : ''}`;
      node.classList.add('c_zeta-facet-option--color');
      nameEl.classList.add('c_zeta-facet-option__color-chip');
      nameEl.textContent = '';
      nameEl.style.background = COLOR_SWATCHES[colorName] || '';
      if (!COLOR_SWATCHES[colorName]) nameEl.classList.add('is-fallback');
      const colorNameEl = document.createElement('span');
      colorNameEl.className = 'c_zeta-facet-option__color-name';
      colorNameEl.textContent = colorName;
      label.appendChild(colorNameEl);
      label.title = accessibleName;
      label.setAttribute('aria-label', accessibleName);
      countEl2.hidden = true;
    }

    // チェック変更時 → state 更新 → 再fetch
    checkbox.addEventListener('change', (e) => {
      onFilterToggle(def.key, valueStr, e.target.checked);
    });

    // 子階層（カテゴリのみ）。TODO: クライアント確認後 — 親子連動仕様（現状完全独立）・子が空のカテゴリ表示扱い（現状トグル非表示）。
    if (!isChild && def.hasChildren && Array.isArray(entry.child) && entry.child.length > 0) {
      childToggle.hidden = false;
      childToggle.addEventListener('click', () => {
        const expanded = childToggle.getAttribute('aria-expanded') === 'true';
        childToggle.setAttribute('aria-expanded', String(!expanded));
        childrenWrap.hidden = expanded;
      });
      const frag = document.createDocumentFragment();
      entry.child.forEach((c) => {
        if (c.count === 0) return; // 件数0は非表示（一般ECの慣例）
        frag.appendChild(buildFacetOption(def, c, true));
      });
      childrenWrap.appendChild(frag);
    }

    if (isChild) node.classList.add('c_zeta-facet-option--child');
    return node;
  };

  // ファセットグループを1つ生成。
  const buildFacetGroup = (def, entries) => {
    facetNameMaps[def.key] = buildFacetNameMap(entries);
    const node = tplFacetGroup.content.firstElementChild.cloneNode(true);
    node.dataset.cZetaFacetGroup = def.key;
    node.querySelector('[data-c_zeta-facet-label]').textContent = def.label;
    if (SLIDE_FACETS.has(def.key)) node.classList.add('c_zeta-facet-group--slide');

    const toggleBtn = node.querySelector('[data-c_zeta-facet-toggle]');
    const optionsList = node.querySelector('[data-c_zeta-facet-options]');
    let actions = null;
    if (def.key === 'color') optionsList.classList.add('c_zeta-facet-group__options--color');

    // 初期開閉（本番実測: 販売タイプ/在庫状況/性別/カテゴリーは開・それ以外は閉）
    const open = !!def.defaultOpen;
    toggleBtn.setAttribute('aria-expanded', String(open));
    optionsList.hidden = !open;

    toggleBtn.addEventListener('click', () => {
      // SPかつ横スライド対象は、アコーディオンでなくサブパネル（横スライド）を開く
      if (SLIDE_FACETS.has(def.key) && isSP()) {
        openSubPanel(def, entries);
        return;
      }
      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      optionsList.hidden = expanded;
      if (actions) actions.hidden = expanded;
    });

    const frag = document.createDocumentFragment();
    entries.forEach((entry) => {
      if (entry.count === 0) return;
      frag.appendChild(buildFacetOption(def, entry, false));
    });
    optionsList.appendChild(frag);

    // OK項目はPCで「OK」「クリア」を表示（SPはCSSで隠し一括ボタンに集約）
    if (OK_FACETS.has(def.key)) {
      actions = document.createElement('div');
      actions.className = 'c_zeta-facet-group__actions';
      actions.hidden = !open;
      const clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.className = 'c_zeta-facet-group__clear';
      clearBtn.textContent = 'クリア';
      clearBtn.addEventListener('click', () => {
        delete draft.filters[def.key];
        applyFacet(def.key);
      });
      const okBtn = document.createElement('button');
      okBtn.type = 'button';
      okBtn.className = 'c_zeta-search__apply-btn c_zeta-facet-group__ok';
      okBtn.textContent = 'OK';
      okBtn.addEventListener('click', async () => {
        await applyFacet(def.key);
        scrollToPageTop();
      });
      actions.appendChild(clearBtn);
      actions.appendChild(okBtn);
      node.appendChild(actions);
    }
    return node;
  };

  // ---------- 価格レンジ（入力欄→適用ボタン） ----------
  const normalizePrice = (v) => {
    const digits = String(v == null ? '' : v).replace(/[^\d]/g, '');
    if (digits === '') return '';
    return String(Math.min(PRICE_MAX, Math.max(PRICE_MIN, parseInt(digits, 10))));
  };

  // 価格を適用（from>toは入替）。PCは即適用、SPはdraftへ入れ一括ボタンで確定。
  const applyPriceRange = async (fromVal, toVal) => {
    let from = normalizePrice(fromVal);
    let to = normalizePrice(toVal);
    if (from !== '' && to !== '' && Number(from) > Number(to)) {
      const tmp = from;
      from = to;
      to = tmp;
    }
    if (isFullPriceRange(from, to)) {
      from = '';
      to = '';
    }
    draft.priceFrom = from;
    draft.priceTo = to;
    if (isSP()) {
      scheduleSpCount(); // SPは「この条件で絞り込む」で一括確定（件数だけBG更新）
      return;
    }
    state.priceFrom = from;
    state.priceTo = to;
    state.o = 0;
    pushUrl();
    await fetchAndRender();
  };

  // 動的生成グループ（価格）用。snippets/c_zeta-facet-group.liquid と同一のシェブロンSVG
  const FACET_CHEVRON_SVG =
    '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-linecap="round"/></svg>';

  // 価格の入力欄を生成する（PC/SPとも入力欄のみで操作、レンジバーは廃止）。
  const buildPriceGroup = () => {
    const section = document.createElement('section');
    section.className = 'c_zeta-facet-group c_zeta-facet-group--price';
    section.dataset.cZetaFacetGroup = 'price';

    const heading = document.createElement('h3');
    heading.className = 'c_zeta-facet-group__heading';
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'c_zeta-facet-group__toggle';
    toggle.setAttribute('aria-expanded', 'true');
    const labelSpan = document.createElement('span');
    labelSpan.className = 'c_zeta-facet-group__label';
    labelSpan.textContent = '価格';
    const chevron = document.createElement('span');
    chevron.className = 'c_zeta-facet-group__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML = FACET_CHEVRON_SVG;
    toggle.appendChild(labelSpan);
    toggle.appendChild(chevron);
    heading.appendChild(toggle);
    section.appendChild(heading);

    const body = document.createElement('div');
    body.className = 'c_zeta-facet-group__options c_zeta-price';

    const row = document.createElement('div');
    row.className = 'c_zeta-price__row';

    const makeField = (val, ariaLabel) => {
      const wrap = document.createElement('span');
      wrap.className = 'c_zeta-price__field';
      const unit = document.createElement('span');
      unit.className = 'c_zeta-price__unit';
      unit.textContent = '¥';
      const input = document.createElement('input');
      input.type = 'number';
      input.inputMode = 'numeric';
      input.min = String(PRICE_MIN);
      input.max = String(PRICE_MAX);
      input.step = String(PRICE_STEP);
      input.className = 'c_zeta-price__input';
      input.setAttribute('aria-label', ariaLabel);
      input.value = val || '';
      wrap.appendChild(unit);
      wrap.appendChild(input);
      return { wrap, input };
    };

    const fromField = makeField(draft.priceFrom, '価格の下限');
    const sep = document.createElement('span');
    sep.className = 'c_zeta-price__sep';
    sep.textContent = '〜';
    const toField = makeField(draft.priceTo, '価格の上限');
    row.appendChild(fromField.wrap);
    row.appendChild(sep);
    row.appendChild(toField.wrap);
    body.appendChild(row);

    // 価格入力欄の値を未確定draftへ反映する（入力中の表示値は書き換えない。書き換えるとmin/max境界へ強制クランプされ、途中まで入力した桁が消えて入力自体ができなくなるため）。
    const syncDraftFromFields = () => {
      draft.priceFrom = normalizePrice(fromField.input.value);
      draft.priceTo = normalizePrice(toField.input.value);
      if (isSP()) scheduleSpCount();
    };

    const actions = document.createElement('div');
    actions.className = 'c_zeta-facet-group__actions c_zeta-price__actions';
    const apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'c_zeta-search__apply-btn c_zeta-price__apply';
    apply.textContent = 'OK';
    const runApply = async () => {
      await applyPriceRange(fromField.input.value, toField.input.value);
      if (!isSP()) scrollToPageTop();
    };
    apply.addEventListener('click', runApply);
    [fromField.input, toField.input].forEach((inp) => {
      inp.addEventListener('input', syncDraftFromFields);
      inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          runApply();
        }
      });
    });
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'c_zeta-facet-group__clear';
    clear.textContent = 'クリア';
    clear.addEventListener('click', () => {
      fromField.input.value = '';
      toField.input.value = '';
      syncDraftFromFields();
      applyPriceRange('', '');
    });
    actions.appendChild(clear);
    actions.appendChild(apply);
    body.appendChild(actions);
    section.appendChild(body);

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      body.hidden = expanded;
    });

    return section;
  };

  // ---------- セレクトブランド モーダル（頭文字検索＋複数選択→OK） ----------
  let selectBrandModal = null;
  let selectBrandEntries = [];
  let selectBrandGroup = '全て';

  const getBrandInitial = (name) => {
    const initial = String(name || '').trim().charAt(0).toUpperCase();
    return /^[A-Z]$/.test(initial) ? initial : 'その他';
  };

  // IME ON のまま入力された全角英数・半角カナを半角/全角へ寄せてから比較する
  const normalizeBrandSearchText = (text) => String(text || '').normalize('NFKC').toLowerCase();

  // 読みかな比較用。中黒・空白を落として「ザ・ノース・フェイス」を「ざのーすふぇいす」でも引けるようにする
  const KANA_NOISE_PATTERN = /[・･\s]/g;
  const KATAKANA_PATTERN = /[\u30a1-\u30f6]/g;
  const KATAKANA_TO_HIRAGANA_OFFSET = 0x60;

  const toHiragana = (text) => String(text || '').replace(
    KATAKANA_PATTERN,
    (char) => String.fromCharCode(char.charCodeAt(0) - KATAKANA_TO_HIRAGANA_OFFSET)
  );

  // 検索語・インデックスの双方をひらがなへ寄せる。カタカナ入力でもひらがな入力でも同じ索引に当たる
  const normalizeKanaSearchText = (text) => toHiragana(normalizeBrandSearchText(text)).replace(KANA_NOISE_PATTERN, '');

  const filterSelectBrandList = (query) => {
    if (!selectBrandModal) return;
    const q = normalizeBrandSearchText(query).trim();
    const kanaQuery = normalizeKanaSearchText(query);
    selectBrandModal.querySelectorAll('.c_zeta-modal__item').forEach((li) => {
      const name = li.dataset.name || '';
      const kana = li.dataset.kana || '';
      const hit = name.indexOf(q) !== -1 || (kanaQuery !== '' && kana !== '' && kana.indexOf(kanaQuery) !== -1);
      li.hidden = q !== '' && !hit;
    });
    selectBrandModal.querySelectorAll('.c_zeta-modal__group').forEach((group) => {
      const groupOk = selectBrandGroup === '全て' || group.dataset.initial === selectBrandGroup;
      group.hidden = !groupOk || !group.querySelector('.c_zeta-modal__item:not([hidden])');
    });
  };

  const populateSelectBrandModal = () => {
    if (!selectBrandModal) return;
    const list = selectBrandModal.querySelector('[data-sb-list]');
    clearChildren(list);
    const selected = draft.filters.selectbrand || new Set();
    const groups = new Map();
    selectBrandEntries.forEach((entry) => {
      if (entry.count === 0) return;
      const displayName = entry.name != null ? String(entry.name) : String(entry.value);
      const initial = getBrandInitial(displayName);
      if (!groups.has(initial)) groups.set(initial, []);
      groups.get(initial).push(entry);
    });
    ['ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''), ['その他']].flat().forEach((initial) => {
      const entries = groups.get(initial);
      if (!entries || !entries.length) return;
      const group = document.createElement('li');
      group.className = 'c_zeta-modal__group';
      group.id = `c-zeta-brand-${initial === 'その他' ? 'other' : initial.toLowerCase()}`;
      group.dataset.initial = initial;
      const heading = document.createElement('h3');
      heading.className = 'c_zeta-modal__group-heading';
      heading.textContent = `${initial} (${entries.reduce((sum, entry) => sum + Number(entry.count || 0), 0)})`;
      const items = document.createElement('ul');
      items.className = 'c_zeta-modal__group-items';
      entries.forEach((entry) => {
        const valueStr = String(entry.value);
        const li = document.createElement('li');
        li.className = 'c_zeta-modal__item';
        const label = document.createElement('label');
        label.className = 'c_zeta-facet-option__label';
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.className = 'c_zeta-facet-option__checkbox';
        cb.value = valueStr;
        if (selected.has(valueStr)) cb.checked = true;
        cb.addEventListener('change', (e) => onFilterToggle('selectbrand', valueStr, e.target.checked));
        const name = document.createElement('span');
        name.className = 'c_zeta-facet-option__name';
        name.textContent = entry.name != null ? String(entry.name) : valueStr;
        const cnt = document.createElement('span');
        cnt.className = 'c_zeta-facet-option__count';
        cnt.textContent = entry.count != null ? `(${entry.count})` : '';
        li.dataset.name = normalizeBrandSearchText(name.textContent);
        // ZETAファセットの読みかな。片方しか返らない場合に備え、あるほうをひらがなへ寄せて索引にする
        li.dataset.kana = normalizeKanaSearchText(entry.name_hira || entry.name_kata || '');
        label.appendChild(cb);
        label.appendChild(name);
        label.appendChild(cnt);
        li.appendChild(label);
        items.appendChild(li);
      });
      group.appendChild(heading);
      group.appendChild(items);
      list.appendChild(group);
    });
  };

  const closeSelectBrandModal = () => {
    if (selectBrandModal) {
      selectBrandModal.classList.remove('is-open');
      if (isSP()) {
        window.setTimeout(() => {
          if (!selectBrandModal.classList.contains('is-open')) selectBrandModal.hidden = true;
        }, 250);
      } else {
        selectBrandModal.hidden = true;
      }
    }
    const drawerStillOpen = facetsAside && facetsAside.classList.contains('is-open');
    document.body.style.overflow = drawerStillOpen ? 'hidden' : '';
  };

  const buildSelectBrandModal = () => {
    const overlay = document.createElement('div');
    overlay.className = 'c_zeta-modal';
    overlay.hidden = true;

    const panel = document.createElement('div');
    panel.className = 'c_zeta-modal__panel';

    const head = document.createElement('div');
    head.className = 'c_zeta-modal__head';
    const backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'c_zeta-modal__back';
    backBtn.textContent = '‹ 戻る';
    backBtn.addEventListener('click', closeSelectBrandModal);
    const title = document.createElement('span');
    title.className = 'c_zeta-modal__title';
    title.textContent = 'セレクトブランド';
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'c_zeta-modal__close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closeSelectBrandModal);
    head.appendChild(backBtn);
    head.appendChild(title);
    head.appendChild(closeBtn);

    const alphabet = document.createElement('nav');
    alphabet.className = 'c_zeta-modal__alphabet';
    alphabet.setAttribute('aria-label', 'ブランド頭文字');
    ['全て', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''), 'その他'].forEach((initial) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'c_zeta-modal__alphabet-button';
      if (initial === '全て') button.classList.add('is-active');
      button.textContent = initial;
      button.addEventListener('click', () => {
        selectBrandGroup = initial;
        alphabet.querySelectorAll('.c_zeta-modal__alphabet-button').forEach((btn) => {
          btn.classList.toggle('is-active', btn === button);
        });
        filterSelectBrandList(search.value);
        const list = selectBrandModal.querySelector('[data-sb-list]');
        if (list) list.scrollTo({ top: 0, behavior: 'smooth' });
      });
      alphabet.appendChild(button);
    });

    const searchWrap = document.createElement('div');
    searchWrap.className = 'c_zeta-modal__search';
    const search = document.createElement('input');
    search.type = 'search';
    search.className = 'c_zeta-modal__search-input';
    search.setAttribute('data-sb-search', '');
    search.placeholder = 'ブランド名で検索';
    search.setAttribute('aria-label', 'ブランド名で検索');
    search.addEventListener('input', () => filterSelectBrandList(search.value));
    searchWrap.appendChild(search);

    const list = document.createElement('ul');
    list.className = 'c_zeta-modal__list';
    list.setAttribute('data-sb-list', '');

    const foot = document.createElement('div');
    foot.className = 'c_zeta-modal__foot';
    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'c_zeta-facet-group__clear';
    clearBtn.textContent = 'クリア';
    clearBtn.addEventListener('click', () => {
      delete draft.filters.selectbrand;
      populateSelectBrandModal();
      updateSelectedLabels();
    });
    const okBtn = document.createElement('button');
    okBtn.type = 'button';
    okBtn.className = 'c_zeta-search__apply-btn c_zeta-modal__ok';
    okBtn.textContent = 'OK';
    okBtn.addEventListener('click', async () => {
      closeSelectBrandModal();
      if (isSP()) scheduleSpCount();
      else {
        await applyFacet('selectbrand');
        scrollToPageTop();
      }
    });
    foot.appendChild(clearBtn);
    foot.appendChild(okBtn);

    panel.appendChild(head);
    // 検索窓 -> アルファベットの順で並べる。SPは media query の order で並びを固定しているためDOM順の変更を受けない
    panel.appendChild(searchWrap);
    panel.appendChild(alphabet);
    panel.appendChild(list);
    panel.appendChild(foot);
    overlay.appendChild(panel);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeSelectBrandModal();
    });
    root.appendChild(overlay);
    return overlay;
  };

  const openSelectBrandModal = () => {
    if (!selectBrandModal) selectBrandModal = buildSelectBrandModal();
    selectBrandGroup = '全て';
    selectBrandModal.querySelectorAll('.c_zeta-modal__alphabet-button').forEach((btn) => {
      btn.classList.toggle('is-active', btn.textContent === '全て');
    });
    populateSelectBrandModal();
    filterSelectBrandList('');
    selectBrandModal.hidden = false;
    void selectBrandModal.offsetWidth; // display:none解除直後の強制リフロー。無いとスライドイン遷移が開始状態を持たずスキップされる
    selectBrandModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const input = selectBrandModal.querySelector('[data-sb-search]');
    if (input) {
      input.value = '';
      setTimeout(() => input.focus(), 0);
    }
  };

  // セレクトブランドのグループ（モーダルを開くトリガーを表示）
  const buildModalTriggerGroup = (def, entries) => {
    facetNameMaps[def.key] = buildFacetNameMap(entries);
    selectBrandEntries = entries;
    const node = tplFacetGroup.content.firstElementChild.cloneNode(true);
    node.dataset.cZetaFacetGroup = def.key;
    node.classList.add('c_zeta-facet-group--slide');
    node.querySelector('[data-c_zeta-facet-label]').textContent = def.label;
    const toggleBtn = node.querySelector('[data-c_zeta-facet-toggle]');
    const optionsList = node.querySelector('[data-c_zeta-facet-options]');
    toggleBtn.setAttribute('aria-expanded', 'true');
    optionsList.hidden = false;
    toggleBtn.addEventListener('click', () => {
      if (isSP()) {
        openSelectBrandModal();
        return;
      }
      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      optionsList.hidden = expanded;
    });
    const li = document.createElement('li');
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'c_zeta-facet-group__modal-trigger';
    const selCount = (draft.filters.selectbrand && draft.filters.selectbrand.size) || 0;
    trigger.textContent = selCount > 0 ? `ブランドを選択（${selCount}）` : 'ブランドを選択';
    trigger.addEventListener('click', openSelectBrandModal);
    li.appendChild(trigger);
    optionsList.appendChild(li);
    return node;
  };

  // ---------- SP 横スライドサブパネル（カテゴリ/ブランドの詳細選択） ----------
  let subPanel = null;
  let subPanelBody = null;
  let subPanelTitle = null;
  let subPanelCurrent = null;

  const closeSubPanel = () => {
    if (!subPanel) return;
    subPanel.classList.remove('is-open');
    window.setTimeout(() => {
      if (!subPanel.classList.contains('is-open')) subPanel.hidden = true;
    }, 250);
  };

  const buildSubPanel = () => {
    subPanel = document.createElement('div');
    subPanel.className = 'c_zeta-search__subpanel';
    subPanel.hidden = true;

    const head = document.createElement('div');
    head.className = 'c_zeta-search__subpanel-head';
    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'c_zeta-search__subpanel-back';
    back.setAttribute('aria-label', '戻る');
    back.textContent = '‹ 戻る';
    back.addEventListener('click', closeSubPanel);
    subPanelTitle = document.createElement('span');
    subPanelTitle.className = 'c_zeta-search__subpanel-title';
    head.appendChild(back);
    head.appendChild(subPanelTitle);

    subPanelBody = document.createElement('ul');
    subPanelBody.className = 'c_zeta-search__subpanel-body c_zeta-facet-group__options';

    const foot = document.createElement('div');
    foot.className = 'c_zeta-search__subpanel-foot';
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'c_zeta-facet-group__clear';
    clear.textContent = 'クリア';
    clear.addEventListener('click', () => {
      if (!subPanelCurrent) return;
      delete draft.filters[subPanelCurrent.def.key];
      // 先にチェックを外し、未選択条件の再取得後に非表示だった選択肢を復帰させる
      openSubPanel(subPanelCurrent.def, subPanelCurrent.entries);
      refreshSpFacets({ reopenSubPanel: true });
      updateSelectedLabels();
    });
    const done = document.createElement('button');
    done.type = 'button';
    done.className = 'c_zeta-search__apply-btn';
    done.textContent = 'OK';
    done.addEventListener('click', closeSubPanel);
    foot.appendChild(clear);
    foot.appendChild(done);

    subPanel.appendChild(head);
    subPanel.appendChild(subPanelBody);
    subPanel.appendChild(foot);
    root.appendChild(subPanel);
  };

  // サブパネルを開きオプションを描画（チェックはdraft・戻る/決定でリストへ・一括で確定）
  const openSubPanel = (def, entries) => {
    if (!subPanel) buildSubPanel();
    subPanelCurrent = { def, entries };
    subPanelTitle.textContent = def.label;
    clearChildren(subPanelBody);
    subPanelBody.classList.toggle('c_zeta-facet-group__options--color', def.key === 'color');
    subPanelBody.dataset.cZetaFacetGroup = def.key;
    const frag = document.createDocumentFragment();
    entries.forEach((entry) => {
      if (entry.count === 0) return;
      frag.appendChild(buildFacetOption(def, entry, false));
    });
    subPanelBody.appendChild(frag);
    subPanel.hidden = false;
    subPanel.scrollTop = 0;
    subPanel.classList.add('is-open');
  };

  // サイズ表示の条件: カテゴリ or ブランドが選択済みか（仕様書赤字）
  // SPは適用前でもサイズを出すため、チェック表示の真のソースであるdraftを見る
  const isCatOrBrandSelected = () =>
    !!(draft.filters.category && draft.filters.category.size) ||
    !!(draft.filters.brand && draft.filters.brand.size) ||
    baseKeys.indexOf('category') !== -1 ||
    baseKeys.indexOf('brand') !== -1;

  // ファセット全体を再描画（表示順はDISPLAY_ORDER）
  const renderFacets = (facet, hasResults) => {
    if (!facetsList || !facet) return;
    clearChildren(facetsList);
    if (!showFilters) {
      if (facetsAside) facetsAside.hidden = true;
      return;
    }
    const frag = document.createDocumentFragment();

    const showPrice = hasResults && baseKeys.indexOf(PRICE_FROM_KEY) === -1 && baseKeys.indexOf(PRICE_TO_KEY) === -1;
    const catBrandSelected = isCatOrBrandSelected();

    // 各グループを事前生成（キー→ノード）してから表示順に並べる
    const groups = {};
    FACET_DEFS.forEach((def) => {
      if (baseKeys.indexOf(def.key) !== -1) return; // 固定条件の軸は絞り込みに出さない（コレクション範囲の破壊防止）
      if (def.key === 'size' && !catBrandSelected) return; // サイズはカテゴリ/ブランド選択時のみ表示
      const entries = facet[def.key];
      if (!Array.isArray(entries) || entries.length === 0) return;
      const visibleCount = entries.reduce((acc, e) => acc + (e.count > 0 ? 1 : 0), 0);
      if (visibleCount === 0) return;
      // セレクトブランドはモーダルトリガー、それ以外は通常グループ
      groups[def.key] = MODAL_FACETS.has(def.key) ? buildModalTriggerGroup(def, entries) : buildFacetGroup(def, entries);
    });

    // '__price__'の位置に価格レンジを挿入
    let hasAny = false;
    DISPLAY_ORDER.forEach((key) => {
      if (key === '__price__') {
        if (showPrice) frag.appendChild(buildPriceGroup());
        return;
      }
      if (groups[key]) {
        frag.appendChild(groups[key]);
        hasAny = true;
      }
    });

    facetsList.appendChild(frag);
    facetsAside.hidden = !(hasAny || showPrice);
    updateSelectedLabels();
  };

  // チップ（適用中フィルター）を再描画。
  const renderActiveFilters = () => {
    if (!chipsList || !activeFiltersBar) return;
    clearChildren(chipsList);
    if (!showFilters) {
      activeFiltersBar.hidden = true;
      return;
    }

    const labelMap = buildLabelMap();
    let total = 0;
    FACET_KEYS.forEach((key) => {
      const set = state.filters[key];
      if (!set || !set.size) return;
      Array.from(set).forEach((v) => {
        total += 1;
        const li = document.createElement('li');
        li.className = 'c_zeta-search__chip';

        const label = document.createElement('span');
        // TODO: クライアント確認後 — `stock_flg=1` を「在庫あり」と表記するか確認
        const level = ICON_FACETS.has(key) ? parseInt(v, 10) : 0;
        const isLevelIcon = level >= 1 && level <= 3;
        // フィールドレベルは数値だけでは条件が伝わらないため絞り込みUIと同じ山アイコンで示す
        const chipName = isLevelIcon
          ? `フィールドレベル${level}`
          : (labelMap[key] && labelMap[key][v] ? labelMap[key][v] : v);
        if (isLevelIcon) {
          label.className = 'c_zeta-search__chip-level';
          label.setAttribute('aria-label', chipName);
          label.appendChild(makeMountainIcon(level));
        } else {
          label.textContent = chipName;
        }

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'c_zeta-search__chip-remove';
        btn.setAttribute('aria-label', `${chipName} を解除`);
        btn.textContent = '×';
        btn.addEventListener('click', () => removeFilterValue(key, v));

        li.appendChild(label);
        li.appendChild(btn);
        chipsList.appendChild(li);
      });
    });

    // キーワードチップ（フリーワード検索。×で検索窓もクリア）
    if (state.q) {
      total += 1;
      const li = document.createElement('li');
      li.className = 'c_zeta-search__chip';
      const label = document.createElement('span');
      label.textContent = state.q;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'c_zeta-search__chip-remove';
      btn.setAttribute('aria-label', `${state.q} を解除`);
      btn.textContent = '×';
      btn.addEventListener('click', () => removeKeyword());
      li.appendChild(label);
      li.appendChild(btn);
      chipsList.appendChild(li);
    }

    // 価格チップ（1つにまとめ×で両端クリア）
    if ((state.priceFrom || state.priceTo) && !isFullPriceRange(state.priceFrom, state.priceTo)) {
      total += 1;
      const yen = (v) => `¥${Number(v).toLocaleString('ja-JP')}`;
      const li = document.createElement('li');
      li.className = 'c_zeta-search__chip';
      const label = document.createElement('span');
      if (state.priceFrom && state.priceTo) label.textContent = `${yen(state.priceFrom)}〜${yen(state.priceTo)}`;
      else if (state.priceFrom) label.textContent = `${yen(state.priceFrom)}以上`;
      else label.textContent = `${yen(state.priceTo)}以下`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'c_zeta-search__chip-remove';
      btn.setAttribute('aria-label', `${label.textContent} を解除`);
      btn.textContent = '×';
      btn.addEventListener('click', () => {
        state.priceFrom = '';
        state.priceTo = '';
        draft.priceFrom = '';
        draft.priceTo = '';
        state.o = 0;
        pushUrl();
        fetchAndRender();
      });
      li.appendChild(label);
      li.appendChild(btn);
      chipsList.appendChild(li);
    }

    activeFiltersBar.hidden = total === 0;
  };

  // 値→表示名のラベルマップを最新ファセットから構築（fetchごとに更新されるため最新分をキャッシュ）。
  let labelCache = {};
  const buildLabelMap = () => labelCache;
  const updateLabelCache = (facet) => {
    if (!facet) return;
    const next = {};
    FACET_KEYS.forEach((key) => {
      const entries = facet[key];
      if (!Array.isArray(entries)) return;
      next[key] = next[key] || {};
      const walk = (list) => {
        list.forEach((e) => {
          next[key][String(e.value)] = e.name != null ? String(e.name) : String(e.value);
          if (Array.isArray(e.child) && e.child.length) walk(e.child);
        });
      };
      walk(entries);
    });
    // 既存マップに値を追加（古い選択値のラベルも保持するため）
    Object.keys(next).forEach((key) => {
      labelCache[key] = Object.assign({}, labelCache[key] || {}, next[key]);
    });
  };

  // ZETAは0件レスポンスでファセットを空配列で返すため、初回表示がいきなり0件だと
  // labelCacheが空のままとなりチップにタグ生値（例: outdoor_goods）が出る。
  // 選択中の値にラベル未解決が残る場合のみ、条件なしリクエストでラベルマスタを1回だけ取得する。
  const LABEL_MASTER_STORAGE_KEY = 'c_zeta_label_master';
  let labelMasterFetched = false;

  // sessionStorageの保存済みラベルを復元する（既存のlabelCacheを優先して上書きしない）
  const restoreLabelCache = () => {
    try {
      const raw = sessionStorage.getItem(LABEL_MASTER_STORAGE_KEY);
      if (!raw) return;
      const saved = JSON.parse(raw);
      if (!saved || typeof saved !== 'object') return;
      Object.keys(saved).forEach((key) => {
        if (FACET_KEYS.indexOf(key) === -1) return;
        labelCache[key] = Object.assign({}, saved[key], labelCache[key] || {});
      });
    } catch (e) {
      // sessionStorage不可（プライベートブラウジング等）は復元しない仕様
    }
  };

  // 取得済みラベルを保存する（同一セッションの他ページでも初回描画から正しいラベルを出すため）
  const saveLabelCache = () => {
    try {
      sessionStorage.setItem(LABEL_MASTER_STORAGE_KEY, JSON.stringify(labelCache));
    } catch (e) {
      // 保存できない環境では次回も都度取得する仕様
    }
  };

  // 選択中の絞り込みにラベル未解決の値が残っているか（フィールドレベルはアイコン表示のため対象外）
  const hasUnresolvedChipLabel = () => FACET_KEYS.some((key) => {
    if (ICON_FACETS.has(key)) return false;
    const set = state.filters[key];
    if (!set || !set.size) return false;
    return Array.from(set).some((value) => !(labelCache[key] && labelCache[key][value]));
  });

  // 条件なしリクエストでファセットのラベルマスタを取得し、チップを再描画する
  const ensureChipLabels = async () => {
    if (!chipsList || !activeFiltersBar) return;
    // チップを描画しない設定のページでは取りに行かない
    if (sectionConfig.showFilters === false) return;
    if (labelMasterFetched || !hasUnresolvedChipLabel()) return;
    labelMasterFetched = true;
    try {
      const data = await window.Zeta.fetchItems({ l: 1, o: 0 });
      const facet = data && data.result && data.result.facet;
      if (!facet) return;
      updateLabelCache(facet);
      saveLabelCache();
      renderActiveFilters();
    } catch (e) {
      // ラベル解決に失敗しても一覧表示自体は妨げず、生値のまま表示を続ける
      console.warn('[c_zeta-search] ラベルマスタの取得に失敗しました', e);
    }
  };

  restoreLabelCache();

  // ---------- フィルタトグル（draft/適用モデル） ----------
  // チェック変更→draft更新。即時項目は即適用、OK項目/SPは適用待ち（SPは件数のみBG更新）。
  const onFilterToggle = (key, value, on) => {
    if (!draft.filters[key]) draft.filters[key] = new Set();
    if (on) draft.filters[key].add(String(value));
    else {
      draft.filters[key].delete(String(value));
      if (draft.filters[key].size === 0) delete draft.filters[key];
    }
    if (isImmediate(key)) applyImmediateFacet(key);
    else if (isSP()) {
      if (SIZE_SOURCE_FACETS.has(key)) scheduleSpFacetRefresh();
      else scheduleSpCount();
    }
    updateSelectedLabels();
  };

  // 絞り込み・並び替え適用後にページ最上部へ戻す（クライアント要望）
  const scrollToPageTop = () => window.scrollTo(0, 0);

  // ブラウザバック（一覧 -> 詳細 -> 戻る）で離脱前の位置へ戻すための保存キー
  const SCROLL_STORAGE_KEY = 'c_zeta_search_scroll';
  // 保存位置の有効期限。時間が空いた復帰は在庫・並びが変わるため最上部から見せる
  const SCROLL_RESTORE_MAX_AGE_MS = 30 * 60 * 1000;

  // 同一ページ判定キー。絞り込み・ページ番号はすべてクエリに載るためsearchまで含める
  const scrollStorageKey = () => `${window.location.pathname}${window.location.search}`;

  let pendingScrollY = null;

  // 離脱時のスクロール位置をsessionStorageへ保存する
  const saveScrollPosition = () => {
    try {
      const payload = { key: scrollStorageKey(), y: window.scrollY || 0, savedAt: Date.now() };
      sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      // sessionStorage不可（プライベートブラウジング等）は保存しない仕様
    }
  };

  // 保存済みスクロール位置を読む（別ページ・期限切れはnull）
  const readSavedScroll = () => {
    try {
      const raw = sessionStorage.getItem(SCROLL_STORAGE_KEY);
      if (!raw) return null;
      const saved = JSON.parse(raw);
      if (!saved || saved.key !== scrollStorageKey()) return null;
      if (!saved.savedAt || Date.now() - saved.savedAt > SCROLL_RESTORE_MAX_AGE_MS) return null;
      return saved;
    } catch (e) {
      return null;
    }
  };

  const clearSavedScroll = () => {
    try {
      sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    } catch (e) {
      // 削除できなくても復元条件（遷移種別・キー一致）で誤復元は防げる
    }
  };

  // 戻る/進むでの遷移か判定する。リロード・通常遷移では復元せず従来どおり最上部から表示する
  const isBackForwardNavigation = () => {
    const entries =
      typeof performance !== 'undefined' && typeof performance.getEntriesByType === 'function'
        ? performance.getEntriesByType('navigation')
        : null;
    if (entries && entries.length) return entries[0].type === 'back_forward';
    return Boolean(performance && performance.navigation && performance.navigation.type === 2);
  };

  // 結果描画後に保存位置へ戻す。カードは5/6のアスペクト比固定で高さが確定するため画像読み込みは待たない
  const restorePendingScroll = async () => {
    if (pendingScrollY == null) return;
    const targetY = pendingScrollY;
    pendingScrollY = null;
    try {
      // webフォントがfont-display:swapのため、切替で商品名の行数が変わり位置がズレないよう適用完了を待つ
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
    } catch (e) {
      // フォント読み込みに失敗しても復元は続行する
    }
    requestAnimationFrame(() => {
      requestAnimationFrame(() => window.scrollTo(0, targetY));
    });
  };

  // 詳細ページへの離脱・bfcache凍結の直前に位置を保存する
  window.addEventListener('pagehide', saveScrollPosition);
  // iOS Safariでpagehideが発火しないケースの保険
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') saveScrollPosition();
  });

  // bfcache復帰は再描画が走らずscrollRestoration='manual'で標準復元も効かないため直接戻す
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const saved = readSavedScroll();
    if (saved) window.scrollTo(0, saved.y);
  });

  // 即時適用ファセット（PC）の適用後にページ最上部へ戻す（クライアント要望）
  const applyImmediateFacet = async (key) => {
    await applyFacet(key);
    scrollToPageTop();
  };

  // 指定キーのdraftをstate.filtersへ反映して再取得（即時/OK/チップ解除の共通経路）
  const applyFacet = async (key) => {
    if (draft.filters[key] && draft.filters[key].size) state.filters[key] = new Set(draft.filters[key]);
    else delete state.filters[key];
    state.o = 0; // フィルター変更時は1ページ目へ戻る
    pushUrl();
    await fetchAndRender();
  };

  // チップの×で該当値を解除（draftからも消して即適用）。
  const removeFilterValue = (key, value) => {
    if (draft.filters[key]) {
      draft.filters[key].delete(String(value));
      if (!draft.filters[key].size) delete draft.filters[key];
    }
    applyFacet(key);
  };

  // キーワードチップの×で検索ワードを解除（検索窓の値も同時にクリア）
  const removeKeyword = () => {
    state.q = '';
    state.o = 0;
    if (searchInput) searchInput.value = '';
    pushUrl();
    fetchAndRender();
  };

  // SP一括: draft全体をstate.filters/priceへ反映し一度だけ再取得してドロワーを閉じる
  const applyAll = async () => {
    FACET_KEYS.forEach((key) => {
      if (draft.filters[key] && draft.filters[key].size) state.filters[key] = new Set(draft.filters[key]);
      else delete state.filters[key];
    });
    const isFullRange = isFullPriceRange(draft.priceFrom, draft.priceTo);
    state.priceFrom = isFullRange ? '' : draft.priceFrom;
    state.priceTo = isFullRange ? '' : draft.priceTo;
    state.o = 0;
    pushUrl();
    await fetchAndRender();
    closeDrawers();
    scrollToPageTop();
  };

  // SP一括ボタンの件数プレビュー（BG取得で「この条件で絞り込む(N件)」を更新）
  let spApplyBtn = null;
  let spCountTimer = null;
  let spCountReq = 0;
  const SP_COUNT_DEBOUNCE_MS = 250;
  const setSpApplyLabel = (total) => {
    if (!spApplyBtn) return;
    spApplyBtn.textContent = total == null ? 'この条件で絞り込む' : `この条件で絞り込む（${total}件）`;
  };
  const scheduleSpCount = () => {
    if (!spApplyBtn) return;
    if (spCountTimer) clearTimeout(spCountTimer);
    spApplyBtn.classList.add('is-loading');
    spCountTimer = setTimeout(async () => {
      const reqId = ++spCountReq;
      try {
        const data = await window.Zeta.fetchItems(draftToApiParams());
        if (reqId !== spCountReq) return; // 古い応答は破棄
        const total = (data && data.result && data.result.attribute && data.result.attribute.total) || 0;
        setSpApplyLabel(total);
      } catch (_) {
        if (reqId === spCountReq) setSpApplyLabel(null);
      } finally {
        if (reqId === spCountReq && spApplyBtn) spApplyBtn.classList.remove('is-loading');
      }
    }, SP_COUNT_DEBOUNCE_MS);
  };

  // SPクリア時は未選択状態のファセットを取り直し、絞り込みで消えた選択肢を復帰させる。
  const refreshSpFacets = async ({ sizeOnly = false, reopenSubPanel = false } = {}) => {
    if (spCountTimer) clearTimeout(spCountTimer);
    const reqId = ++spCountReq;
    if (spApplyBtn) spApplyBtn.classList.add('is-loading');
    try {
      const data = await window.Zeta.fetchItems(draftToApiParams());
      if (reqId !== spCountReq) return; // 古い応答は破棄
      const total = (data && data.result && data.result.attribute && data.result.attribute.total) || 0;
      const facet = (data && data.result && data.result.facet) || {};
      const facetForUi = sizeOnly ? Object.assign({}, lastFacet, { size: facet.size || [] }) : facet;
      const scrollTop = sizeOnly && facetsAside ? facetsAside.scrollTop : 0;
      renderFacets(facetForUi, sizeOnly ? lastHasResults : total > 0);
      if (reopenSubPanel && subPanelCurrent && subPanel && !subPanel.hidden) {
        const entries = facetForUi[subPanelCurrent.def.key];
        if (Array.isArray(entries)) openSubPanel(subPanelCurrent.def, entries);
      }
      if (sizeOnly && facetsAside) facetsAside.scrollTop = scrollTop;
      setSpApplyLabel(total);
    } catch (_) {
      if (reqId === spCountReq) setSpApplyLabel(null);
    } finally {
      if (reqId === spCountReq && spApplyBtn) spApplyBtn.classList.remove('is-loading');
    }
  };

  // カテゴリー/ブランド選択直後にサイズを出すため、ドラフト条件でのファセット再取得を間引いて実行する
  const scheduleSpFacetRefresh = () => {
    if (!spApplyBtn) return;
    if (spCountTimer) clearTimeout(spCountTimer);
    spApplyBtn.classList.add('is-loading');
    spCountTimer = setTimeout(() => refreshSpFacets({ sizeOnly: true }), SP_COUNT_DEBOUNCE_MS);
  };

  const clearAll = async () => {
    state.filters = {};
    state.priceFrom = '';
    state.priceTo = '';
    state.q = '';
    if (searchInput) searchInput.value = '';
    seedDraft();
    state.o = 0;
    pushUrl();
    await fetchAndRender();
    scrollToPageTop();
  };

  if (clearAllBtn) clearAllBtn.addEventListener('click', clearAll);

  const pushUrl = () => {
    const qs = buildUrlFromState();
    const newUrl = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`;
    window.history.pushState({ zeta: true }, '', newUrl);
  };

  // popstate（戻る/進む）対応
  window.addEventListener('popstate', () => {
    stateFromUrl();
    fetchAndRender();
  });

  // ---------- ソートUI ----------
  let sortButton = null;
  let sortList = null;
  let spSortList = null;

  const onSortChange = async (value) => {
    state.s = SORT_VALUES.indexOf(value) !== -1 ? value : DEFAULT_SORT;
    state.o = 0; // 並び替え変更時は1ページ目へ戻す
    pushUrl();
    await fetchAndRender();
    scrollToPageTop(); // PC/SPとも並び替えリストは共通のため両方で最上部へ戻す（クライアント要望）
  };

  const currentSortLabel = () => {
    const current =
      SORT_OPTIONS.find((option) => option.value === state.s) ||
      SORT_OPTIONS.find((option) => option.value === DEFAULT_SORT);
    return current.label;
  };

  const closeSortMenus = () => {
    [sortList, spSortList].forEach((list) => {
      if (list) list.hidden = true;
    });
    if (sortButton) sortButton.setAttribute('aria-expanded', 'false');
    if (openSortBtn) openSortBtn.setAttribute('aria-expanded', 'false');
  };

  const buildSortList = () => {
    const list = document.createElement('div');
    list.className = 'c_zeta-search__sort-list';
    list.hidden = true;
    availableSortOptions().forEach((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'c_zeta-search__sort-option';
      button.dataset.value = option.value;
      button.textContent = option.label;
      button.addEventListener('click', async () => {
        closeSortMenus();
        await onSortChange(option.value);
      });
      list.appendChild(button);
    });
    return list;
  };

  const buildSort = () => {
    if (!sortEl || !toolbarEl) return;
    if (!showSortBy) return;
    sortButton = document.createElement('button');
    sortButton.type = 'button';
    sortButton.className = 'c_zeta-search__sort-button';
    sortButton.setAttribute('aria-haspopup', 'listbox');
    sortButton.setAttribute('aria-expanded', 'false');
    sortButton.addEventListener('click', () => {
      const willOpen = sortList.hidden;
      closeSortMenus();
      sortList.hidden = !willOpen;
      sortButton.setAttribute('aria-expanded', String(willOpen));
    });
    sortList = buildSortList();
    sortList.setAttribute('role', 'listbox');
    sortEl.appendChild(sortButton);
    sortEl.appendChild(sortList);
    toolbarEl.hidden = false;
  };

  // popstate等でstate.sが変わったとき各ソートUIを同期する。
  const updateSortValue = () => {
    if (sortButton) sortButton.textContent = `並び替え: ${currentSortLabel()}`;
    [sortList, spSortList].forEach((list) => {
      if (!list) return;
      list.querySelectorAll('.c_zeta-search__sort-option').forEach((button) => {
        const selected = button.dataset.value === state.s;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-selected', String(selected));
      });
    });
  };

  // ---------- SP絞り込みドロワー ----------

  const closeDrawers = () => {
    if (facetsAside) facetsAside.classList.remove('is-open');
    closeSortMenus();
    closeSubPanel();
    if (overlayEl) overlayEl.hidden = true;
    document.body.style.overflow = '';
  };

  // SP一括適用バー（ドロワー下部固定「この条件で絞り込む(件数)」）
  const buildSpApplyBar = () => {
    if (!facetsAside) return;
    const bar = document.createElement('div');
    bar.className = 'c_zeta-search__sp-apply-bar';
    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'c_zeta-search__sp-clear';
    clearBtn.textContent = 'クリア';
    clearBtn.addEventListener('click', () => {
      draft.filters = {};
      draft.priceFrom = '';
      draft.priceTo = '';
      renderFacets(lastFacet, lastHasResults);
      refreshSpFacets();
    });
    spApplyBtn = document.createElement('button');
    spApplyBtn.type = 'button';
    spApplyBtn.className = 'c_zeta-search__sp-apply';
    spApplyBtn.textContent = 'この条件で絞り込む';
    spApplyBtn.addEventListener('click', applyAll);
    bar.appendChild(clearBtn);
    bar.appendChild(spApplyBtn);
    facetsAside.appendChild(bar);
  };

  const openFacetsDrawer = () => {
    seedDraft(); // 常に適用済み状態から開始（未確定のdraft変更は破棄）
    renderFacets(lastFacet, lastHasResults);
    setSpApplyLabel(lastTotal);
    if (facetsAside) {
      facetsAside.scrollTop = 0; // 前回のスクロール位置を持ち越さず常に一番上から開く
      facetsAside.classList.add('is-open');
    }
    if (overlayEl) overlayEl.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const buildSpSort = () => {
    if (!openSortBtn || !spBar) return;
    if (!showSortBy) {
      openSortBtn.hidden = true;
      return;
    }
    openSortBtn.setAttribute('aria-haspopup', 'listbox');
    openSortBtn.setAttribute('aria-expanded', 'false');
    spSortList = buildSortList();
    spSortList.classList.add('c_zeta-search__sort-list--sp');
    spSortList.setAttribute('role', 'listbox');
    spBar.appendChild(spSortList);
    openSortBtn.addEventListener('click', () => {
      const willOpen = spSortList.hidden;
      closeSortMenus();
      spSortList.hidden = !willOpen;
      openSortBtn.setAttribute('aria-expanded', String(willOpen));
    });
  };

  if (openFacetsBtn) {
    if (showFilters) openFacetsBtn.addEventListener('click', openFacetsDrawer);
    else openFacetsBtn.hidden = true;
  }
  if (closeFacetsBtn) closeFacetsBtn.addEventListener('click', closeDrawers);
  if (overlayEl) overlayEl.addEventListener('click', closeDrawers);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-c_zeta-search-sort], [data-c_zeta-search-sp-bar]')) closeSortMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSortMenus();
  });

  // 固定/解除の判定はCSSのstickyに任せ、JSはヘッダー下端のオフセットだけを渡す。
  // スクロール毎の測定は強制レイアウトになるためrAFで1フレーム1回に間引き、
  // 値が変わったときだけ書き込む（書き込み→再測定の往復がカクツキの原因）。
  let spBarHeaderSection = null;
  let spBarFixedTop = null;
  let spBarUpdateQueued = false;

  const getSpBarHeaderSection = () => {
    if (spBarHeaderSection && spBarHeaderSection.isConnected) return spBarHeaderSection;
    const storeHeader = document.querySelector('store-header');
    spBarHeaderSection = storeHeader
      ? storeHeader.closest('.shopify-section') || storeHeader
      : document.querySelector('header');
    return spBarHeaderSection;
  };

  const updateSpBarPosition = () => {
    spBarUpdateQueued = false;
    if (!spBar || !isSP()) return;
    const headerSection = getSpBarHeaderSection();
    const headerBottom = headerSection ? Math.max(0, headerSection.getBoundingClientRect().bottom) : 0;
    if (headerBottom === spBarFixedTop) return;
    spBarFixedTop = headerBottom;
    spBar.style.setProperty('--c-zeta-fixed-top', `${headerBottom}px`);
  };

  const requestSpBarUpdate = () => {
    if (spBarUpdateQueued) return;
    spBarUpdateQueued = true;
    window.requestAnimationFrame(updateSpBarPosition);
  };

  const initSpBarPosition = () => {
    if (!spBar) return;
    spBarHeaderSection = null;
    spBarFixedTop = null;
    updateSpBarPosition();
  };
  window.addEventListener('scroll', requestSpBarUpdate, { passive: true });
  window.addEventListener('resize', initSpBarPosition);

  // ---------- ページネーション（番号方式） ----------
  // 表示するページ番号リストを生成（端では最低5番号、中間は現在±1、先頭/末尾と省略を含む）。
  const buildPageList = (current, totalPages) => {
    const rangeStart = Math.max(Math.min(current - 1, totalPages - 4), 2);
    const rangeEnd = Math.min(Math.max(current + 1, 5), totalPages - 1);
    const pages = [];
    for (let i = 1; i <= totalPages; i += 1) {
      if (i === 1 || i === totalPages || (i >= rangeStart && i <= rangeEnd)) {
        pages.push(i);
      }
    }
    const withDots = [];
    let prev = 0;
    pages.forEach((i) => {
      if (prev) {
        if (i - prev === 2) withDots.push(prev + 1); // 隙間が1つだけなら番号を出す
        else if (i - prev !== 1) withDots.push('…');
      }
      withDots.push(i);
      prev = i;
    });
    return withDots;
  };

  // 指定ページへ遷移（offset更新→再fetch→結果先頭へスクロール）。
  const goToPage = async (page) => {
    const limit = state.l || sectionConfig.productsPerPage || 24;
    state.o = Math.max(0, (page - 1) * limit);
    pushUrl();
    await fetchAndRender();
    const scrollTarget = titleEl || root;
    if (scrollTarget && typeof scrollTarget.scrollIntoView === 'function') {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // 矢印アイコン（テーマ snippets/icon.liquid 'arrow-right-breadcrumb' を踏襲。色はCSSで白に上書き）
  const ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none" aria-hidden="true"><path d="M1 1L5.5 5.5L1 10" stroke-linecap="round"/></svg>';

  // ページネーション用ボタン1つを生成（opts: { current, direction:'prev'|'next', ariaLabel }）。
  const buildPagerButton = (label, page, opts = {}) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'c_zeta-search__pager-item';
    if (opts.direction) {
      btn.classList.add('c_zeta-search__pager-arrow', `c_zeta-search__pager-arrow--${opts.direction}`);
      btn.innerHTML = ARROW_SVG;
    } else {
      btn.textContent = label;
    }
    if (opts.current) btn.classList.add('is-current');
    if (opts.ariaLabel) btn.setAttribute('aria-label', opts.ariaLabel);
    if (opts.current) {
      btn.setAttribute('aria-current', 'page');
    } else {
      btn.addEventListener('click', () => goToPage(page));
    }
    return btn;
  };

  // ページネーション（件数表示＋番号ボタン）を描画。件数表記は本番BoostAI準拠、1ページ目は前/最終ページは次アロー非表示。
  const renderPagination = (total) => {
    if (!paginationEl) return;
    clearChildren(paginationEl);
    if (!showPagination) {
      paginationEl.hidden = true;
      return;
    }
    const limit = state.l || sectionConfig.productsPerPage || 24;
    const totalCount = total || 0;
    if (totalCount <= 0) {
      paginationEl.hidden = true;
      return;
    }
    paginationEl.hidden = false;
    const totalPages = Math.ceil(totalCount / limit);
    const current = Math.min(Math.floor(state.o / limit) + 1, totalPages);

    if (showCount) {
      const start = state.o + 1;
      const end = Math.min(state.o + limit, totalCount);
      const count = document.createElement('p');
      count.className = 'c_zeta-search__pagination-count';
      count.textContent = `全${totalCount}件 ${start} ～ ${end}件表示中`;
      paginationEl.appendChild(count);
    }

    // 番号ボタンは2ページ以上のときのみ
    if (totalPages <= 1) return;

    const nav = document.createElement('nav');
    nav.className = 'c_zeta-search__pager';
    nav.setAttribute('aria-label', 'ページネーション');

    // 前へ（1ページ目では非表示）
    if (current > 1) {
      nav.appendChild(buildPagerButton('', current - 1, { direction: 'prev', ariaLabel: '前のページ' }));
    }

    buildPageList(current, totalPages).forEach((p) => {
      if (p === '…') {
        const span = document.createElement('span');
        span.className = 'c_zeta-search__pager-ellipsis';
        span.textContent = '…';
        nav.appendChild(span);
        return;
      }
      nav.appendChild(buildPagerButton(String(p), p, { current: p === current, ariaLabel: `${p}ページ目` }));
    });

    // 次へ（最終ページでは非表示）
    if (current < totalPages) {
      nav.appendChild(buildPagerButton('', current + 1, { direction: 'next', ariaLabel: '次のページ' }));
    }

    paginationEl.appendChild(nav);
  };

  // ---------- 結果描画 ----------
  const render = (data) => {
    const total = (data && data.result && data.result.attribute && data.result.attribute.total) || 0;
    const items = (data && data.result && data.result.items) || [];
    const facet = (data && data.result && data.result.facet) || {};

    // 件数表示（本番BoostAI準拠: 全○件 ○ ～ ○件表示中）
    if (countEl && showCount) {
      const limit = state.l || sectionConfig.productsPerPage || 24;
      const end = Math.min(state.o + limit, total);
      countEl.textContent = total > 0 ? `全${total}件 ${state.o + 1} ～ ${end}件表示中` : '全0件';
    }
    if (status) status.hidden = true;

    clearChildren(grid);
    if (items.length === 0) {
      const empty = document.createElement('li');
      empty.className = 'c_zeta-search__empty';
      empty.textContent = '該当する商品が見つかりませんでした。';
      grid.appendChild(empty);
    } else {
      const frag = document.createDocumentFragment();
      items.forEach((item, index) => {
        const card = buildCard(item);
        if (card) {
          const rank = card.querySelector('[data-card-rank]');
          if (sectionConfig.showRank === true && state.s === COLLECTION_ORDER_SORT && rank) {
            rank.textContent = state.o + index + 1;
            rank.hidden = false;
          }
          frag.appendChild(card);
        }
      });
      grid.appendChild(frag);
    }

    const hasItems = items.length > 0;
    if (hasItems) lastNonEmptyFacet = facet;
    // 0件時は直前の結果ありfacetでUIを維持し、条件解除で復帰できるようにする
    const facetForUi = hasItems ? facet : (lastNonEmptyFacet || facet);
    const facetUiUsable = hasItems || Boolean(lastNonEmptyFacet);

    // SPドロワーの再描画・件数表示用に直近応答を保持
    lastFacet = facetForUi;
    lastHasResults = facetUiUsable;
    lastTotal = total;

    updateLabelCache(facetForUi);
    renderFacets(facetForUi, facetUiUsable);
    renderActiveFilters();
    // 0件レスポンスはfacetが空でラベルを解決できないため、未解決が残る場合のみマスタを取りに行く
    ensureChipLabels();
    updateSortValue();
    // 0件時は操作不能な絞り込み・並び替えUIを隠し、結果復帰時に再表示する
    if (toolbarEl) toolbarEl.hidden = !hasItems || !sortButton;
    if (spBar) spBar.hidden = !hasItems || (!showFilters && !showSortBy);
    if (facetsAside && !hasItems) facetsAside.hidden = true;
    renderPagination(total);
  };

  const showError = (err) => {
    console.error('[c_zeta-search]', err);
    if (status) {
      status.hidden = false;
      status.textContent = `検索結果の取得に失敗しました（${err.kind || 'error'}）`;
    }
    // TODO: Zeta社確認後 — エラー時にShopify標準検索 /search?q=<q> へリダイレクトするか決定
  };

  const BREADCRUMB_SEARCH_LABEL = '検索結果';

  // pushStateによる部分描画ではLiquid出力のパンくずが初回キーワードのまま残るため、状態に合わせて書き換える
  const syncBreadcrumb = () => {
    const text = state.q ? `${BREADCRUMB_SEARCH_LABEL}“${state.q}”` : BREADCRUMB_SEARCH_LABEL;
    breadcrumbEls.forEach((el) => {
      el.textContent = text;
    });
  };

  // ---------- メインフロー ----------
  const fetchAndRender = async () => {
    // コレクションページはLiquid出力（brタグを含むHTML）を保持し、検索ページのみキーワードを反映する
    if (titleEl && !sectionConfig.pageTitle) {
      titleEl.textContent = state.q ? `「${state.q}」の検索結果` : '検索結果';
    }
    syncBreadcrumb();
    if (status) status.hidden = true;
    try {
      const data = await window.Zeta.fetchItems(stateToApiParams());
      render(data);
    } catch (err) {
      showError(err);
    }
  };

  // ---------- ページ内検索窓（本番BoostAI準拠。c_zeta-searchセクションのみ存在） ----------
  const searchForm = $('[data-c_zeta-search-form]');
  const searchInput = $('[data-c_zeta-search-input]');
  const HISTORY_KEY = 'c_zeta_search_history';
  const HISTORY_MAX = 10;

  /**
   * 検索キーワードを検索履歴（localStorage・ヘッダー検索窓と共通キー）へ保存する
   * @param {string} keyword 保存するキーワード
   */
  const saveHistory = (keyword) => {
    const kw = (keyword || '').trim();
    if (!kw) return;
    try {
      const raw = localStorage.getItem(HISTORY_KEY);
      const list = (raw ? JSON.parse(raw) : []).filter((item) => typeof item === 'string' && item !== kw);
      list.unshift(kw);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(list.slice(0, HISTORY_MAX)));
    } catch (e) {
      // localStorage不可（プライベートブラウジング等）は保存しない仕様
    }
  };

  // キーワードが変わったらソートは引き継がずデフォルトへ戻す（TSI確認済みの仕様）
  const applyKeywordChange = (keyword) => {
    const next = (keyword || '').trim();
    if (next !== state.q) state.s = DEFAULT_SORT;
    state.q = next;
    state.o = 0;
  };

  // URL由来のstateを検索窓へ反映（初期表示・戻る/進む）
  const syncSearchInput = () => {
    if (searchInput) searchInput.value = state.q;
  };

  // ---------- 検索履歴ドロップダウン（フォーカス時に表示・本番BoostAI準拠） ----------
  const historyBox = $('[data-c_zeta-search-history]');
  const historyList = $('[data-c_zeta-search-history-list]');

  /**
   * 検索履歴ドロップダウンを最新のlocalStorage内容で描画する（履歴が無ければ非表示のまま）
   * @returns {boolean} 表示できる履歴があるか
   */
  const renderHistoryDropdown = () => {
    if (!historyBox || !historyList) return false;
    let list = [];
    try {
      const raw = localStorage.getItem(HISTORY_KEY);
      list = (raw ? JSON.parse(raw) : []).filter((kw) => typeof kw === 'string' && kw.trim());
    } catch (e) {
      list = [];
    }
    while (historyList.firstChild) historyList.removeChild(historyList.firstChild);
    if (!list.length) return false;
    const frag = document.createDocumentFragment();
    list.forEach((kw) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'c_zeta-search__history-item';
      btn.textContent = kw;
      btn.addEventListener('click', () => {
        applyKeywordChange(kw);
        saveHistory(kw); // 再検索で先頭へ
        syncSearchInput();
        historyBox.hidden = true;
        pushUrl();
        fetchAndRender();
      });
      li.appendChild(btn);
      frag.appendChild(li);
    });
    historyList.appendChild(frag);
    return true;
  };

  if (searchForm && searchInput) {
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault(); // 画面遷移せずpushState＋再fetch（zeta_devパラメータ維持のため）
      applyKeywordChange(searchInput.value);
      saveHistory(state.q);
      if (historyBox) historyBox.hidden = true;
      pushUrl();
      fetchAndRender();
    });
    window.addEventListener('popstate', syncSearchInput);

    if (historyBox) {
      searchInput.addEventListener('focus', () => {
        historyBox.hidden = !renderHistoryDropdown();
      });
      // 外側クリック・Escapeで閉じる
      document.addEventListener('click', (e) => {
        if (!searchForm.contains(e.target)) historyBox.hidden = true;
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') historyBox.hidden = true;
      });
    }
  }

  // 初回起動
  // リロード時にブラウザのスクロール位置復元を無効化し常に最上部から表示（クライアント要望）
  if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  // 戻る/進むで同じ一覧に戻ったときだけ、離脱前の位置を描画後に復元する
  const savedScroll = isBackForwardNavigation() ? readSavedScroll() : null;
  if (savedScroll) {
    pendingScrollY = savedScroll.y;
    clearSavedScroll();
  } else {
    window.scrollTo(0, 0);
  }
  stateFromUrl(true);
  syncSearchInput();
  buildSort();
  buildSpSort();
  buildSpApplyBar();
  updateSortValue();
  initSpBarPosition();
  (async () => {
    await fetchAndRender();
    await restorePendingScroll();
  })();
})();
